module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"list_user":"User List"},"si":{"list_user":"User List"},"ta":{"list_user":"User List"}}')
  delete Component.options._Ctor
}
